const fieldRules = {
	empty: v => !!v || 'Eingabe erforderlich',
	priceMinValue: v => parseFloat(v.replace(',', '.')) >= 0.01 || 'Mindestwert: 0,01€',
	emptySelection: (v) => v.length > 0 || 'Auswahl erforderlich',
	emptyCheckbox: v => !!v || 'Auswahl erforderlich',
	emptyUpload: (v) => v.length > 0 || 'Dokument erforderlich',
	confirmation: (val1, val2, text) => {
		return (val1 === val2) || text
	},
	length50: v => (v || '').length <= 50 || 'Max. 50 Zeichen',
	email: v => {
		const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		return pattern.test(v) || 'Keine gültige E-Mail-Adresse.'
	},
	length6: v => (v || '').length >= 6 || 'Passwort muss mindestens 6 Zeichen haben',
	zipDE: v => {
		const pattern = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/
		return (pattern.test(v) && (v || '').length === 5) || 'Ungültige Postleitzahl'
	},
	city: v => {
		const pattern = /[a-zA-Z]+(?:[ '-][a-zA-Z]+)*/
		return pattern.test(v) || 'Ungültige Zeichen'
	}
}

export default fieldRules
